/* Zolang Intelligems zijn oude versie nog uit de cache serveert, zetten we de kop goed. */
(function () {
  var GOED = 'See Why Over 100,000 Women Ditched Their Bra';
  var n = 0;
  var iv = setInterval(function () {
    var t = document.querySelector('.mgt-vrs__title span');
    if (t && t.textContent.indexOf('Women') === -1) { t.textContent = GOED; }
    if (++n > 120) { clearInterval(iv); }
  }, 500);
})();
(function () {

  if (window.__mgtVrs) return;

  window.__mgtVrs = 1;



  var CARDS = [{"key":"judy","quote":"I Wore It All Day Long","name":"Judy - Age 74","hls":"https://cdn.shopify.com/videos/c/vp/a60f433be76f461d9647e06f3da7868c/a60f433be76f461d9647e06f3da7868c.m3u8","mp4":"https://cdn.shopify.com/videos/c/vp/a60f433be76f461d9647e06f3da7868c/a60f433be76f461d9647e06f3da7868c.HD-1080p-2.5Mbps-94731942.mp4","poster":"https://cdn.shopify.com/s/files/1/0767/9354/4875/files/maggies-review-judy.jpg?v=1789654395&width=800"},{"key":"donna","quote":"Thinking About Us Old Ladies","name":"Donna - Age 78","hls":"https://cdn.shopify.com/videos/c/vp/ecc46d0f84124e0a9c49ca452844e2a2/ecc46d0f84124e0a9c49ca452844e2a2.m3u8","mp4":"https://cdn.shopify.com/videos/c/vp/ecc46d0f84124e0a9c49ca452844e2a2/ecc46d0f84124e0a9c49ca452844e2a2.HD-1080p-2.5Mbps-94732008.mp4","poster":"https://cdn.shopify.com/s/files/1/0767/9354/4875/files/maggies-review-donna.jpg?v=1789654436&width=800"},{"key":"stephanie","quote":"Theme Park With My Grandkids","name":"Stephanie - Age 67","hls":"https://cdn.shopify.com/videos/c/vp/66f38fe2d63443efa68ae3e87ce18be8/66f38fe2d63443efa68ae3e87ce18be8.m3u8","mp4":"https://cdn.shopify.com/videos/c/vp/66f38fe2d63443efa68ae3e87ce18be8/66f38fe2d63443efa68ae3e87ce18be8.HD-1080p-2.5Mbps-94732074.mp4","poster":"https://cdn.shopify.com/s/files/1/0767/9354/4875/files/maggies-review-stephanie.jpg?v=1789654470&width=800"},{"key":"karen","quote":"I'm Sold","name":"Karen - Age 83","hls":"https://cdn.shopify.com/videos/c/vp/a46d624df1eb460baa4229bcf78ebe23/a46d624df1eb460baa4229bcf78ebe23.m3u8","mp4":"https://cdn.shopify.com/videos/c/vp/a46d624df1eb460baa4229bcf78ebe23/a46d624df1eb460baa4229bcf78ebe23.HD-1080p-2.5Mbps-94732142.mp4","poster":"https://cdn.shopify.com/s/files/1/0767/9354/4875/files/maggies-review-karen_a716d1aa-405f-4713-82a1-bcaa84a11dc4.jpg?v=1789654505&width=800"},{"key":"andrea","quote":"Pleasantly Surprised At 76","name":"Andrea - Age 76","hls":"https://cdn.shopify.com/videos/c/vp/88ddaa35ab6647ed9ed31bace060d0af/88ddaa35ab6647ed9ed31bace060d0af.m3u8","mp4":"https://cdn.shopify.com/videos/c/vp/88ddaa35ab6647ed9ed31bace060d0af/88ddaa35ab6647ed9ed31bace060d0af.HD-1080p-2.5Mbps-94732207.mp4","poster":"https://cdn.shopify.com/s/files/1/0767/9354/4875/files/maggies-review-andrea.jpg?v=1789654535&width=800"},{"key":"ren","quote":"Feels Like A Little Hug","name":"Ren - Age 68","hls":"https://cdn.shopify.com/videos/c/vp/66db270be3a64f18b1d557a4bd5cfcda/66db270be3a64f18b1d557a4bd5cfcda.m3u8","mp4":"https://cdn.shopify.com/videos/c/vp/66db270be3a64f18b1d557a4bd5cfcda/66db270be3a64f18b1d557a4bd5cfcda.HD-1080p-2.5Mbps-94732281.mp4","poster":"https://cdn.shopify.com/s/files/1/0767/9354/4875/files/maggies-review-ren.jpg?v=1789654576&width=800"}];

  var BADGE = "GOING VIRAL ON FACEBOOK";

  var TITLE = "<span>See Why Over 100,000 Women Ditched Their Bra</span><span>Because Of <strong class=\"mgt-vrs__brand\">Maggie's Tanks</strong></span>";



  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }



  function cardHtml(c) {

    return '<div class="mgt-vrs__card" data-name="' + esc(c.key) + '">' +

      '<video class="mgt-vrs__video" loop playsinline webkit-playsinline preload="none" poster="' + esc(c.poster) + '">' +

      '<source src="' + esc(c.hls) + '" type="application/x-mpegURL">' +

      '<source src="' + esc(c.mp4) + '" type="video/mp4"></video>' +

      '<div class="mgt-vrs__shade"></div><div class="mgt-vrs__play"></div>' +

      '<div class="mgt-vrs__info"><h3 class="mgt-vrs__quote">"' + esc(c.quote) + '"</h3>' +

      '<span class="mgt-vrs__name">' + esc(c.name) + '</span></div></div>';

  }



  var ARROW_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

  var ARROW_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';



  function init(sec) {

    var grid = sec.querySelector('.mgt-vrs__grid');

    var track = sec.querySelector('.mgt-vrs__track');

    var n = CARDS.length;

    // two cloned sets each side so the row never runs out while swiping

    var html = '';

    for (var s = 0; s < 5; s++) for (var i = 0; i < n; i++) html += cardHtml(CARDS[i]);

    track.innerHTML = html;

    var cards = track.querySelectorAll('.mgt-vrs__card');



    function posOf(idx) { var c = cards[idx]; return c.offsetLeft - (grid.clientWidth - c.offsetWidth) / 2; }

    function nearest() {

      var mid = grid.scrollLeft + grid.clientWidth / 2, best = 0, bd = 1e9;

      for (var k = 0; k < cards.length; k++) { var c = cards[k], d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = k; } }

      return best;

    }

    function jump(left) {

      grid.style.scrollSnapType = 'none';

      grid.scrollLeft = left;

      requestAnimationFrame(function () { requestAnimationFrame(function () { grid.style.scrollSnapType = ''; }); });

    }

    function pauseAll(except) {

      for (var k = 0; k < cards.length; k++) {

        var v = cards[k].querySelector('video');

        if (v !== except && !v.paused) { v.pause(); }

        if (v !== except) cards[k].classList.remove('is-playing');

      }

    }

    function center() { jump(posOf(2 * n)); }

    center();

    requestAnimationFrame(center);

    setTimeout(center, 300);

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(center);

    var lastW = window.innerWidth;

    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; jump(posOf(nearest())); } });



    var t;

    grid.addEventListener('scroll', function () {

      clearTimeout(t);

      t = setTimeout(function () {

        var idx = nearest();

        if (idx < n || idx >= 4 * n) {

          var target = idx < n ? idx + 2 * n : idx - 2 * n;

          var playing = cards[idx].classList.contains('is-playing');

          if (!playing) jump(grid.scrollLeft + (posOf(target) - posOf(idx)));

        }

      }, 140);

    }, { passive: true });



    function go(step) {

      var idx = nearest() + step;

      if (idx < 0 || idx >= cards.length) return;

      grid.scrollTo({ left: posOf(idx), behavior: 'smooth' });

    }

    sec.querySelector('.mgt-vrs__btn--prev').addEventListener('click', function () { go(-1); });

    sec.querySelector('.mgt-vrs__btn--next').addEventListener('click', function () { go(1); });



    track.addEventListener('click', function (e) {

      var card = e.target.closest('.mgt-vrs__card');

      if (!card) return;

      var v = card.querySelector('video');

      if (v.paused) {

        pauseAll(v);

        if (v.readyState < 2) v.load();

        var p = v.play();

        card.classList.add('is-playing');

        if (p && p.catch) p.catch(function () { card.classList.remove('is-playing'); });

        var idx = Array.prototype.indexOf.call(cards, card);

        if (Math.abs(posOf(idx) - grid.scrollLeft) > 4) grid.scrollTo({ left: posOf(idx), behavior: 'smooth' });

      } else {

        v.pause();

        card.classList.remove('is-playing');

      }

    });



    if ('IntersectionObserver' in window) {

      var io = new IntersectionObserver(function (entries) {

        entries.forEach(function (en) {

          if (en.intersectionRatio < 0.5) {

            var v = en.target.querySelector('video');

            if (!v.paused) { v.pause(); en.target.classList.remove('is-playing'); }

          }

        });

      }, { threshold: [0, 0.25, 0.5, 0.75] });

      for (var k = 0; k < cards.length; k++) io.observe(cards[k]);

    }

  }



  function build() {

    if (document.getElementById('mgt-vrs')) return true;

    var anchor = document.querySelector('.shopify-section[id*="__product_hero_"]');

    if (!anchor || !anchor.parentNode) return false;

    var sec = document.createElement('section');

    sec.id = 'mgt-vrs';

    sec.className = 'mgt-vrs';

    sec.innerHTML = '<div class="mgt-vrs__pillwrap"><span class="mgt-vrs__badge"><span class="mgt-vrs__dot"></span>' + BADGE + '</span></div>' +

      '<h2 class="mgt-vrs__title">' + TITLE + '</h2>' +

      '<div class="mgt-vrs__grid"><div class="mgt-vrs__track"></div></div>' +

      '<div class="mgt-vrs__nav"><button type="button" class="mgt-vrs__btn mgt-vrs__btn--prev" aria-label="Previous videos">' + ARROW_L + '</button>' +

      '<button type="button" class="mgt-vrs__btn mgt-vrs__btn--next" aria-label="Next videos">' + ARROW_R + '</button></div>';

    anchor.parentNode.insertBefore(sec, anchor.nextSibling);

    init(sec);

    return true;

  }



  if (build()) return;

  var tries = 0;

  var iv = setInterval(function () { if (build() || ++tries > 80) clearInterval(iv); }, 250);

  document.addEventListener('DOMContentLoaded', build);

})();

